  var head= document.getElementsByTagName('head')[0];
  var err_style = '';
  try{
    err_style = mc_custom_error_style;
  } catch(e){
    err_style = '#mc_embed_signup input.mce_inline_error{border-color:#6B0505;} #mc_embed_signup div.mce_inline_error{margin: 0 0 1em 0; padding: 5px 10px; background-color:#6B0505; font-weight: bold; z-index: 1; color:#fff;}';
  }
  var head= document.getElementsByTagName('head')[0];
  var style= document.createElement('style');
  style.type= 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = err_style;
  } else {
    style.appendChild(document.createTextNode(err_style));
  }
  head.appendChild(style);
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'http://downloads.mailchimp.com/js/jquery.form-n-validate.js';
  head.appendChild(script);
  setTimeout('mce_preload_check();', 250);

  var mce_preload_checks = 0;
  function mce_preload_check(){
    if (mce_preload_checks>40) return;
    mce_preload_checks++;
    try {
      var jqueryLoaded=jQuery;
    } catch(err) {
      setTimeout('mce_preload_check();', 250);
      return;
    }
    try {
      var validatorLoaded = jQuery("#fake-form").validate({});
    } catch(err) {
      setTimeout('mce_preload_check();', 250);
      return;
    }
    mce_init_form();
  }
  function mce_init_form(){
    $(function(){
        MailChimpPopupForm.Initialize();
    });
  }

var VisitingCookieTracker = {Status: '', PageView:0, Visits:0, PopupAlreadyShownOnVisit:[]};
var MailChimpPopupForm = {
    HideForm:function(saveCookie){
        $('#mc_embed_signup').hide();
		if(saveCookie){
			//this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ErrorInSubmitted,'','','',1);
		}
    },
    ReadCookiesAndShowPopup:function(){
		var sessionCookie = CookieManager.ReadCookie(_SessionCookieName);
		var mce_cookie_value = this.ReadJsonFromCookie(_MC_cookie_name);

		if(mce_cookie_value == null && sessionCookie == null){
		    CookieManager.CreateCookie(_SessionCookieName, 1);
			this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ShowOnNextVisit,1,1,'',30);
            mce_cookie_value = this.ReadJsonFromCookie(_MC_cookie_name);
		}else{

			if(mce_cookie_value == null){
				this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ShowOnNextVisit,1,1,'',30);
				mce_cookie_value = this.ReadJsonFromCookie(_MC_cookie_name);
			}

			if(sessionCookie == null){
				var obj = mce_cookie_value;
				var visitNumber = obj.Visits + 1;
				var pageViewNumber = obj.PageView;
				CookieManager.CreateCookie(_SessionCookieName, visitNumber);
				if(obj.Status == CookieValues.ShowOnNextVisit){
					this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ShowOnNextVisit,pageViewNumber,visitNumber,'',30);
				}
			}
		}

		if(mce_cookie_value.Status == CookieValues.ShowOnNextVisit && ($.inArray(window.location.href, _PopupPageUrl) != -1)){
			this.ProcessCookiesValuesAndShowPopupIfNeeded();
		}

    },
	SaveJsonToCookie:function(cookieName,status,pageview,visits,visitpopupshown,duration){
		VisitingCookieTracker.Status = status;
		VisitingCookieTracker.PageView = pageview;
		VisitingCookieTracker.Visits = visits;
		if(visitpopupshown != ''){
			VisitingCookieTracker.PopupAlreadyShownOnVisit.push(visitpopupshown);
		}
		CookieManager.CreateCookie(cookieName,JSON.stringify(VisitingCookieTracker),duration);
	},
	ReadJsonFromCookie:function(cookieName){
		var cookieObj = CookieManager.ReadCookie(cookieName);
        var obj = null;
		if(cookieObj != null){
            try{
                obj = JSON.parse(cookieObj);
            }catch(e){
                if(cookieObj.indexOf(CookieValues.HasSubmitted) != -1){
                    MailChimpPopupForm.SaveJsonToCookie(cookieName,CookieValues.HasSubmitted,'','','',365)
                    obj = JSON.parse(CookieManager.ReadCookie(cookieName));
                }
            }
		}
        return obj;
	},
    DataObj:{
		PageView:0,
		Visits:0,
		NeedToShowPopupOnCurrentVisit:false,
		NeedToShowPopupOnCurrentPageView:false,
		PopupAlreadyShown: false,
		ShowPopup:false
	},
	ProcessCookiesValuesAndShowPopupIfNeeded:function(){
		var cookieObj = this.ReadJsonFromCookie(_MC_cookie_name);
		this.DataObj.PageView = parseInt(cookieObj.PageView);
		this.DataObj.Visits = parseInt(cookieObj.Visits);
		if(cookieObj.PopupAlreadyShownOnVisit.length > 0){
			this.DataObj.PopupAlreadyShown = ($.inArray(this.DataObj.Visits,cookieObj.PopupAlreadyShownOnVisit) != -1)
		}

		this.DataObj.NeedToShowPopupOnCurrentVisit = (($.inArray(this.DataObj.Visits, _Visits) != -1) && !this.DataObj.PopupAlreadyShown);
		this.DataObj.NeedToShowPopupOnCurrentPageView = (this.DataObj.PageView == _PageViewNumber);

		if(this.DataObj.NeedToShowPopupOnCurrentVisit){
		   if(this.DataObj.PageView <= _PageViewNumber){
				if(this.DataObj.NeedToShowPopupOnCurrentPageView){
					this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ShowOnNextVisit,1,this.DataObj.Visits,this.DataObj.Visits,30);
				}else{
					var pageview = this.DataObj.PageView + 1;
					this.SaveJsonToCookie(_MC_cookie_name,CookieValues.ShowOnNextVisit,pageview,this.DataObj.Visits,'',30);
				}
		   }
		}

		if(this.DataObj.Visits > _Visits[_Visits.length - 1]){
			//Visiting number is bigger
		}

		if(this.DataObj.NeedToShowPopupOnCurrentVisit && this.DataObj.NeedToShowPopupOnCurrentPageView){
			this.DataObj.ShowPopup = true;
			this.ShowForm(null);
		}
	},
    ShowForm:function(delay){
		var delay = delay == null ? _Popup_delay : delay;
		$('#mc_embed_signup a.mc_embed_close').show();
		setTimeout( function(){ 
		  $('#mc_embed_signup').fadeIn();
		}, delay);
		MailChimpPopupForm.LoadValidator();
		MailChimpPopupForm.FormSubmit();
	},
	LoadValidator:function(){
		var bValidatorOptions = {
			singleError:true
		};
		$('#mc_embed_signup form').bValidator(bValidatorOptions);
	},
	FormSubmit:function(){
		var formElem = $('#mc_embed_signup form');
		formElem.bind('submit', function(e){
			var url = _URL + $(this).serialize() + '&c=?';
			var options = { 
				url: url, 
				type: 'GET', 
				dataType: 'json', 
				contentType: "application/json; charset=utf-8",
				success: MailChimpPopupForm.Success
			};
			formElem.ajaxSubmit(options);
			e.preventDefault();
			return false;
		});
	},
	InitKeyEvents:function(){
		$(document).keydown(function(e){
			keycode = e == null ? event.keyCode : e.which;
			if(keycode == 27){
				MailChimpPopupForm.HideForm(true);
			}
		});
	},
	InitTopSignUpButton:function(){
		$("#Top-SignUp-button").click(function(e){
			MailChimpPopupForm.ShowForm(100);
			e.stopPropagation();
			return false;
		});
	},
	Initialize:function(){
		$('#mc_embed_signup a.mc_embed_close').click(function(){
			MailChimpPopupForm.HideForm(true);
		});
		this.HideForm(false);
		this.ReadCookiesAndShowPopup();
		this.InitKeyEvents();
		this.InitTopSignUpButton();
	},
	Success:function(resp){
		$('#mce-success-response').hide();
		$('#mce-error-response').hide();
		if (resp.result=="success"){
			MailChimpPopupForm.SaveJsonToCookie(_MC_cookie_name,CookieValues.HasSubmitted,'','','',365)
			$('#mce-'+resp.result+'-response').show();
			$('#mce-'+resp.result+'-response').html(resp.msg);
			$('#mc-embedded-subscribe-form input[type="text"]').each(function(){
				$(this).val('');
			});
			$('#submit-container #mc-embedded-subscribe').prop('disabled','disabled');

			setTimeout(function(){
				MailChimpPopupForm.HideForm();
			},4500);

		}else{
			MailChimpPopupForm.SaveJsonToCookie(_MC_cookie_name,CookieValues.ErrorInSubmitted,'','','',2);
			var index = -1;
			var msg;
			try {
				var parts = resp.msg.split(' - ',2);
				if (parts[1]==undefined){
					msg = resp.msg;
				} else {
					i = parseInt(parts[0]);
					if (i.toString() == parts[0]){
						index = parts[0];
						msg = parts[1];
					} else {
						index = -1;
						msg = resp.msg;
					}
				}
			} catch(e){
				index = -1;
				msg = resp.msg;
			}
			try{
				if (index== -1){
					$('#mce-'+resp.result+'-response').show();
					$('#mce-'+resp.result+'-response').html(msg);            
				} else {
					err_id = 'mce_tmp_error_msg';
					html = '<div id="'+err_id+'" style="'+err_style+'"> '+msg+'</div>';

					var input_id = '#mc_embed_signup';
					var f = $(input_id);
					if (ftypes[index]=='address'){
						input_id = '#mce-'+fnames[index]+'-addr1';
						f = $(input_id).parent().parent().get(0);
					} else if (ftypes[index]=='date'){
						input_id = '#mce-'+fnames[index]+'-month';
						f = $(input_id).parent().parent().get(0);
					} else {
						input_id = '#mce-'+fnames[index];
						f = $().parent(input_id).get(0);
					}
					if (f){
						$(f).append(html);
						$(input_id).focus();
					} else {
						$('#mce-'+resp.result+'-response').show();
						$('#mce-'+resp.result+'-response').html(msg);
					}
				}
			} catch(e){
				$('#mce-'+resp.result+'-response').show();
				$('#mce-'+resp.result+'-response').html(msg);
			}
		}

	}

};

var MailChimpLastCallForm = {
    Init:function(){
        MailChimpLastCallForm.Container = $('#mc_embed_lastcall');
        MailChimpLastCallForm.BindKeyEvents();
        $('#mc_embed_close', MailChimpLastCallForm.Container).click(function(){
    		MailChimpLastCallForm.HideAndNavigateToUrl();
		});
		
        $('#last-call-link').click(function(e){
            var cookieValue = CookieManager.ReadCookie(MailChimpLastCallForm.CookieName);
            if(cookieValue == null || cookieValue == MailChimpLastCallForm.CookieValues.NotSubscribedToLastCall){
                MailChimpLastCallForm.Show();
                e.stopPropagation();
                return false;
            }
        });
    },
    BindKeyEvents:function(){
        $(document).keydown(function(e){
    		keycode = e == null ? event.keyCode : e.which;
			if(keycode == 27){
				MailChimpLastCallForm.HideAndNavigateToUrl();
			}
		});
    },
    HideAndNavigateToUrl:function(){
        MailChimpLastCallForm.Container.hide();
        var url =  $('#last-call-link').attr('href');
        window.location = url;
    },
    Show:function(){
        setTimeout( function(){ 
    	  MailChimpLastCallForm.Container.fadeIn();
		}, 250);
		MailChimpLastCallForm.LoadValidator();
		MailChimpLastCallForm.FormSubmit();
    },
    LoadValidator:function(){
    	var bValidatorOptions = {
			singleError:true
		};
		$('form',MailChimpLastCallForm.Container).bValidator(bValidatorOptions);
	},
    FormSubmit:function(){
    	var formElem = $('form', MailChimpLastCallForm.Container);
		formElem.bind('submit', function(e){
			var url = formElem.attr('action') + $(this).serialize() + '&c=?';
			var options = { 
				url: url, 
				type: 'GET', 
				dataType: 'json', 
				contentType: "application/json; charset=utf-8",
				success: MailChimpLastCallForm.Success
			};
			formElem.ajaxSubmit(options);
			e.preventDefault();
			return false;
		});
	},
    Success:function(resp){
        $('#mce-success-response', MailChimpLastCallForm.Container).hide();
		$('#mce-error-response', MailChimpLastCallForm.Container).hide();
		if (resp.result=="success"){
			CookieManager.CreateCookie(MailChimpLastCallForm.CookieName,MailChimpLastCallForm.CookieValues.HasSubscribedToLastCall,365)
			$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).show();
			$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).html(resp.msg);
			$('input[type="text"]', MailChimpLastCallForm.Container).each(function(){
				$(this).val('');
			});
			$('#mc-embedded-subscribe', MailChimpLastCallForm.Container).prop('disabled','disabled');

            MailChimpLastCallForm.Container.hide(3500,function(){
                var url =  $('#last-call-link').attr('href');
                window.location = url;
            });
		}else{
			CookieManager.CreateCookie(MailChimpLastCallForm.CookieName,MailChimpLastCallForm.CookieValues.NotSubscribedToLastCall,2);
			var index = -1;
			var msg;
			try {
				var parts = resp.msg.split(' - ',2);
				if (parts[1]==undefined){
					msg = resp.msg;
				} else {
					i = parseInt(parts[0]);
					if (i.toString() == parts[0]){
						index = parts[0];
						msg = parts[1];
					} else {
						index = -1;
						msg = resp.msg;
					}
				}
			} catch(e){
				index = -1;
				msg = resp.msg;
			}
			try{
				if (index== -1){
					$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).show();
					$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).html(msg);            
				} else {
					err_id = 'mce_tmp_error_msg';
					html = '<div id="'+err_id+'" style="'+err_style+'"> '+msg+'</div>';

					var input_id = '#mc_embed_signup';
					var f = $(input_id);
					if (ftypes[index]=='address'){
						input_id = '#mce-'+fnames[index]+'-addr1';
						f = $(input_id).parent().parent().get(0);
					} else if (ftypes[index]=='date'){
						input_id = '#mce-'+fnames[index]+'-month';
						f = $(input_id).parent().parent().get(0);
					} else {
						input_id = '#mce-'+fnames[index];
						f = $().parent(input_id).get(0);
					}
					if (f){
						$(f).append(html);
						$(input_id).focus();
					} else {
						$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).show();
						$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).html(msg);
					}
				}
			} catch(e){
				$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).show();
				$('#mce-'+resp.result+'-response', MailChimpLastCallForm.Container).html(msg);
			}
		}
    },
    Container:null,
    CookieName:'TaylorStitchLastCallForm',
	CookieValues: {'HasSubscribedToLastCall':'HasSubscribeToLastCall','NotSubscribedToLastCall':'NotSubscribedToLastCall'}
};

$(function(){
    MailChimpLastCallForm.Init();
});

//Must be in some shared.js
var CookieManager = {
		CreateCookie: function(name,value,days) {
			if (days) {
				var date = new Date();
				date.setTime(date.getTime()+(days*24*60*60*1000));
				var expires = "; expires="+date.toGMTString();
			}
			else var expires = "";
			document.cookie = name+"="+value+expires+"; path=/";
		},

		ReadCookie: function(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		},

		EraseCookie:function (name) {
			createCookie(name,"",-1);
		}
};
